import { signal } from '@preact/signals';
import { Company } from 'cosdb-types';

export const companySignal = signal<Company | undefined>(undefined);
